import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "../../assets/css/Loader.css"
import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import ActionsDropdown from "../ActionsDropdown";



const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};





function Incomelist() {
  const [responseData, setResponseData] = useState([]);
  const [responseDatas, setResponseDatas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [ispreviewModal, setispreviewModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [branch, setbranch] = useState([]);
  const [student, setstudent] = useState([]);
  const [paymenttype, setpaymenttype] = useState([]);
  const [responseDatased, setResponseDatased] = useState([]);



  const [role_id, setroleid] = useState('');

  const [previllages, setprevillages] = useState({})
  // current date//////////////////////////////
  const formatDate = (date) => {
    if (!(date instanceof Date)) {
      date = new Date(date); // Convert input to Date if it's not already
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  const [addData, setAddData] = useState({
    branch_id: "",
    type: "",
    date: formatDate(new Date()),
    description: "",
    paid_by: "",
    paid_to: "",
    paytype: "",
    amount: "",
    paid_till_date: "",
    payment_due_date: "",
    next_due_date: "",
    person_name: "",
    contact: "",
    other_details: "",
    email: "",
  });

  const handleDateChange = (e) => {
    setUpdateData((prevData) => ({
      ...prevData,
      date: e.target.value, // Input type=date handles the format
    }));
  };



  const handleDateChanged = (e) => {
    setUpdateData((prevData) => ({
      ...prevData,
      paid_till_date: e.target.value, // Input type=date handles the format
    }));
  };


  const handleDateChangedd = (e) => {
    setUpdateData((prevData) => ({
      ...prevData,
      payment_due_date: e.target.value, // Input type=date handles the format
    }));
  };


  const handleDateChangeddd = (e) => {
    setUpdateData((prevData) => ({
      ...prevData,
      next_due_date: e.target.value, // Input type=date handles the format
    }));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "/income_list", {
        params: { data: localStorage.getItem("branch_id") }
      });

      console.log("Response from server:12", response.data);
      setResponseData(response.data.reverse());

      if (response && response.status === 200) {
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }


    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [updateData, setUpdateData] = useState({
    branch_id: "",
    type: "",
    date: formatDate(new Date()),
    description: "",
    paid_by: "",
    paid_to: "",
    paytype: "",
    amount: "",
    paid_till_date: "",
    payment_due_date: "",
    next_due_date: "",
    person_name: "",
    contact: "",
    other_details: "",
    email: "",
  });

  useEffect(() => {
    fetchDatas();
    fetchDatased();
    gettoken();
    studyingstudent();
    paymenttyperoute();
    fetchbranch();
  }, []);


  const fetchbranch = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("Response from server type:", response.data);
      setbranch(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };



  const fetchDatas = async () => {
    try {
      const response = await axios.get(apiUrl + "/income_type");
      console.log("Response from server type:", response.data);
      // Ensure the response.data is an array before setting it
      if (Array.isArray(response.data)) {
        setResponseDatas(response.data);
      } else {
        setResponseDatas([]); // Fallback to an empty array if data is not an array
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setResponseDatas([]); // Optionally handle this case by setting an empty array
    }
  };


  const fetchDatased = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("Response from server brach :", response.data);
      setResponseDatased(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };



  const studyingstudent = async () => {
    try {
      const response = await axios.get(apiUrl + "/studingstudent");
      console.log("Response from server:", response.data);
      setstudent(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };


  const paymenttyperoute = async () => {
    try {
      const response = await axios.get(apiUrl + "/paytype");
      console.log("Response from server:", response.data);
      setpaymenttype(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };



  // const handleNewButtonClick = () => {
  //   setShowModal(true);
  // };





  const gettoken = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;
      if (id) {
        try {
          const response = await axios.get(apiUrl + `/role_2/${id}`);

          const modules = response.data.modules;

          const filtered_access = modules.filter(
            (item) => item.name == "Additional Income"
          );

          setprevillages(filtered_access[0].actions);
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };







  const handlesubmit = async (e) => {
    e.preventDefault();

    if (!validateFields()) {

    }

    try {
      setLoading(true);
      const formData = {
        // branch_id: addData.branch_id,
        // type: addData.type,
        // date: addData.date,
        // description: addData.description,
        // paid_by: addData.paid_by,
        // paid_to: addData.paid_to,

        // paytype: addData.paytype,
        // amount: addData.amount,


        branch_id: addData.branch_id,
        type: addData.type || "",  // Ensure type is never undefined
        date: addData.date || formatDate(new Date()),
        description: addData.description || "",
        paid_by: addData.paid_by || "",
        paid_to: addData.paid_to || "",
        paytype: addData.paytype || "",
        amount: addData.amount || "",
        paid_till_date: addData.paid_till_date,
        payment_due_date: addData.payment_due_date,
        next_due_date: addData.next_due_date,
        person_name: addData.person_name,
        contact: addData.contact,
        other_details: addData.other_details,
        email: addData.email,


      };
      console.log("the post Formdata:", formData);
      const response = await axios.post(apiUrl + "/income_list", formData);
      console.log("the post income list:", response);
      setShowModal(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
      toast.success("added successfully!");
      setAddData({
        branch_id: "",
        type: "",
        date: formatDate(new Date()),
        description: "",
        paid_by: "",
        paid_to: "",
        paytype: "",
        amount: "",
        paid_till_date: "",
        payment_due_date: "",
        next_due_date: "",
        person_name: "",
        contact: "",
        other_details: "",
        email: '',
      });
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to updata", data);
    setUpdateShowModal(true);
    setUpdateData({
      branch_name: data.branch,
      // branch_id: data.branch_id,

      branch_id: data.branch_id._id,      // type: data.type[0].type,
      type: data.type[0]._id,
      date: data.date,
      description: data.description,
      paid_by: data.paid_by,
      paid_to: data.paid_to,
      paytype: data.paytype,
      amount: data.amount,
      paid_till_date: data.paid_till_date,
      payment_due_date: data.payment_due_date,
      next_due_date: data.next_due_date,
      person_name: data.person_name,
      contact: data.contact,
      other_details: data.other_details,
      email: data.email,
    });
  };



  const handlepreview = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to updata", data);
    setispreviewModal(true);
    setUpdateData({
      branch_name: data.branch,
      // branch_id: data.branch_id,

      branch_id: data.branch_id._id,      // type: data.type[0].type,
      type: data.type[0]._id,
      date: data.date,
      description: data.description,
      paid_by: data.paid_by,
      paid_to: data.paid_to,
      paytype: data.paytype,
      amount: data.amount,
      paid_till_date: data.paid_till_date,
      payment_due_date: data.payment_due_date,
      next_due_date: data.next_due_date,
      person_name: data.person_name,
      contact: data.contact,
      other_details: data.other_details,
      email: data.email,
    });
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        branch_id: updateData.branch_id,
        type: updateData.type,
        date: updateData.date,
        description: updateData.description,
        paid_by: updateData.paid_by,
        paid_to: updateData.paid_to,
        paytype: updateData.paytype,
        amount: updateData.amount,
        paid_till_date: updateData.paid_till_date,
        payment_due_date: updateData.payment_due_date,
        next_due_date: updateData.next_due_date,
        person_name: updateData.person_name,
        contact: updateData.contact,
        other_details: updateData.other_details,
        email: updateData.email,
      };
      console.log("the update submit data", formData);
      const response = await axios.put(
        apiUrl + `/income_list/${updateid}`,
        formData
      );
      console.log("response for update", response);
      setUpdateShowModal(false);
      toast.success("Update successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await axios.delete(apiUrl + `/income_list/${getdeleteid}`);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error deleting role:", error.message);
    }
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = (_id, description) => {
    console.log(" the id", _id);
    console.log(" the name", description);
    setdeleteid(_id);
    setdeletename(description);
    setDeleteShowModals(true);
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Search
  const filtered = currentItems.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };
  // the pagination  end ---------------------------------------------------------------------


  // const createPagination = () => {
  //   let liTag = [];
  //   let beforePage = currentPage - 1;
  //   let afterPage = currentPage + 1;
  //   let active;

  //   if (currentPage > 1) {
  //     liTag.push(
  //       <li className="page-item" key="prev">
  //         <button
  //           className="page-link"
  //           onClick={() => paginate(currentPage - 1)}
  //         >
  //           <FaAngleLeft /> Prev
  //         </button>
  //       </li>
  //     );
  //   }

  //   if (currentPage > 2) {
  //     liTag.push(
  //       <li className="page-item" key="first" onClick={() => paginate(1)}>
  //         <button className="page-link">1</button>
  //       </li>
  //     );
  //     if (currentPage > 3) {
  //       liTag.push(
  //         <li className="page-item disabled" key="dots1">
  //           <span className="page-link">...</span>
  //         </li>
  //       );
  //     }
  //   }

  //   if (currentPage === totalPages) {
  //     beforePage -= 2;
  //   } else if (currentPage === totalPages - 1) {
  //     beforePage -= 1;
  //   }

  //   if (currentPage === 1) {
  //     afterPage += 2;
  //   } else if (currentPage === 2) {
  //     afterPage += 1;
  //   }

  //   for (let plength = beforePage; plength <= afterPage; plength++) {
  //     if (plength > totalPages || plength <= 0) continue;
  //     active = currentPage === plength ? "active" : "";
  //     liTag.push(
  //       <li
  //         className={`page-item ${active}`}
  //         key={plength}
  //         onClick={() => paginate(plength)}
  //       >
  //         <button className="page-link">{plength}</button>
  //       </li>
  //     );
  //   }

  //   if (currentPage < totalPages - 1) {
  //     if (currentPage < totalPages - 2) {
  //       liTag.push(
  //         <li className="page-item disabled" key="dots2">
  //           <span className="page-link">...</span>
  //         </li>
  //       );
  //     }
  //     liTag.push(
  //       <li
  //         className="page-item"
  //         key="last"
  //         onClick={() => paginate(totalPages)}
  //       >
  //         <button className="page-link">{totalPages}</button>
  //       </li>
  //     );
  //   }

  //   if (currentPage < totalPages) {
  //     liTag.push(
  //       <li className="page-item" key="next">
  //         <button
  //           className="page-link"
  //           onClick={() => paginate(currentPage + 1)}
  //         >
  //           Next <FaAngleRight />
  //         </button>
  //       </li>
  //     );
  //   }

  //   return liTag;
  // };


  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };





  // ===================================================
  const navigate = useNavigate();

  const handleIncomeType = () => {
    navigate("/incometype");
  };

  // Helper function to format ISO date to YYYY-MM-DD
  // const formatDatefitching = (isoDate) => {
  //   if (!isoDate) return ""; // Return an empty string if no date is provided
  //   const date = new Date(isoDate);
  //   return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  // };



  // const handleBranchSelection = (e) => {
  //   console.log(responseDatased, "responseDatased", e.target.value);

  //   // Ensure the types of e.target.value and branch_id are the same
  //   const selectedBranch = responseDatased.find(
  //     (item) => item.branch_name === e.target.value.toString()
  //   );

  //   if (selectedBranch) {
  //     console.log("The selected branch is:", selectedBranch);
  //     setselectedbranch({
  //       branch_id: selectedBranch.branch_id,
  //       branch_name: selectedBranch.branch_name,
  //     });
  //   } else {
  //     console.log("No matching branch found.");
  //   }
  // };


  // const [selectedbranch, setselectedbranch] = useState({
  //   branch_id: "",
  //   branch_name: "",
  // });



  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    if (!addData.branch_id) {
      tempErrors.branch_id = "Branch Name is required.";
      isValid = false;
    }

    if (!addData.type) {
      tempErrors.type = "Type is required.";
      isValid = false;
    }

    if (!addData.date) {
      tempErrors.date = "Date is required.";
      isValid = false;
    }

    if (!addData.description) {
      tempErrors.description = "Description is required.";
      isValid = false;
    }

    if (!addData.paid_by) {
      tempErrors.paid_by = "Paid By is required.";
      isValid = false;
    }

    if (!addData.paid_to) {
      tempErrors.paid_to = "Paid To is required.";
      isValid = false;
    }

    if (!addData.paytype) {
      tempErrors.paytype = "Paytype is required.";
      isValid = false;
    }


    if (!addData.amount) {
      tempErrors.amount = "Amount is required.";
      isValid = false;
    }

    if (!addData.other_details) {
      tempErrors.other_details = "other_details is required.";
      isValid = false;
    }


    if (!addData.email) {
      tempErrors.email = "Email is required.";
      isValid = false;
    }


    setErrors(tempErrors);
    return isValid;
  }





  // const formatDatefitching = (isoDate) => {
  //   if (!isoDate) return ""; // Return an empty string if no date is provided
  //   const date = new Date(isoDate);

  //   const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
  //   const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
  //   const year = date.getFullYear();

  //   return `${day}-${month}-${year}`; // Format as "day-month-year"
  // };



  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };




  const formatDataaae = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };


  const [rolename, setrolename] = useState([]);
  useEffect(() => {

    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);


  const [loading, setLoading] = useState(false);





  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      // branch: item.branch_id?.branch_name,
      branch_id: {
        _id: item.branch_id._id,
        branch_name: item.branch_id.branch_name,
      },
      type: item.type,
      paid_by: item.paid_by,
      date: item.date,
      paid_to: item.paid_to,
      person_name: item.person_name,
      paytype: item.paytype,
      amount: item.amount,
      description: item.description,
      contact: item.contact,
      email: item.email,





    }));
  }, [responseData]);

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => {
          return row.index + 1;
        },
      },
      {
        Header: "Branch",
        accessor: "branch_id.branch_name", // The key here is branch_id
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        // Custom cell rendering to display the branch name
        // Cell: ({ value }) => value?.branch_name || "N/A", // Safely accessing branch_name
      },
      {
        Header: "Type",
        accessor: "type",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Paid By",
        accessor: "paid_by",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Date",
        accessor: "date",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          const date = new Date(value);  // Convert the ISO string to a Date object
          const day = String(date.getDate()).padStart(2, '0');  // Add leading zero if necessary
          const month = String(date.getMonth() + 1).padStart(2, '0');  // Get the month (zero-indexed, so add 1)
          const year = date.getFullYear();

          return `${day}-${month}-${year}`;  // Return the formatted date
        }
      },
      {
        Header: "Paid To",
        accessor: "paid_to",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Person Name",
        accessor: "person_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "PayType",
        accessor: "paytype",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Amount",
        accessor: "amount",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },



    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );









  return (

    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-9">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Income List</b>
              </Link>
              {/* <Link to="" className="text-danger dashBoard_text">
                            <b>Profile</b>
                        </Link> */}
            </div>
            <div className="col-lg-3 d-flex justify-content-end">
              <button className="btn btn-secondary" onClick={handleIncomeType}>
                Income Type
              </button>
            </div>
          </div>
        </div>

        {/* <div className="row">
          <div className="col-lg-10">
            
          </div>
          
        </div> */}

        {/* ------------ search and per page ----------------------------*/}

        {/* <div className="mb-3 mt-3">
          <div className="row">
            <div className="col-lg-2 col-md-4 col-sm-4 d-flex">
              <label className="form-label text-dark mt-2">Show : </label>
              <div>
                <select
                  className="form-control w-100 mx-2"
                  onChange={(e) => {
                    setItemsPerPage(e.target.value);
                  }}
                >
               
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
            <div className="col-lg-7 col-md-4 col-sm-1"></div>
            <div className="col-lg-3 col-md-4 col-sm-7">
              <div className="w-full flex-1">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white  appearance-none pl-8  dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div> */}

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className="d-flex">
                <h5 className="mt-1">Additional Income List</h5>
                <div className="mx-3">

                  {/* {previllages.add && ( */}
                  <button className="btn  add" onClick={() => setShowModal(true)}>
                    Add{" "}
                  </button>
                  {/* )} */}
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>



        {/* --------------------------------end------------------------------------------- */}

        {/* <div className="card">
          <div className="mt-1">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  {rolename === "Branches" && (<th>Branch</th>)}
                  <th>Type</th>
                  <th>Date</th>
                
                  <th>Paid By</th>
                  <th>Paid To</th>
                  <th>Person Name</th>
                  <th>Pay Type</th>
                  <th>Amount</th>

                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    {rolename === "Branches" && (
                      <td>{item.branch_id}</td>
                    )}
                    <td>{item.type}</td>
                    <td>{formatDataaae(item.date)}</td>
                    <td>{item.paid_by}</td>
                    <td>{item.paid_to}</td>
                    <td>{item.person_name}</td>
                    <td>{item.paytype}</td>
                    <td>{item.amount}</td>

                    <td className="text-center">
                      {previllages.edit && (
                        <button
                          className="btn updelete mx-2"
                          onClick={() => handleUpdate(item._id, item)}
                        >
                          <i class="fa-solid fa-pen-to-square"></i>
                        </button>
                      )}
                      {previllages.delete && (
                        <button
                          className="btn delete"
                          onClick={() =>
                            handleOpenModal(item._id, item.description)
                          }
                        >
                          <i class="fa-solid fa-trash-can"></i>
                        </button>
                      )}


                      <button
                        className="btn updelete mx-2"
                        onClick={() => handlepreview(item._id, item)}
                      >
                        <i class="fa-solid fa-circle-info"></i>
                      </button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}




        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.description)
                      }
                      onInfo={(id, row) =>
                        handlepreview(id, row)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>





        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Additional Income List</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">


                  {/* <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>

                    <select
                      className="form-select"
                      value={addData.branch_name} // Controlled by state
                      onChange={(e) => handleBranchSelection(e)} // Handles branch selection
                      required
                    >
                      <option value="">Select Branch</option>
                      {responseDatased.map((item, index) => (
                        <option key={index} value={item.branch_name}>
                          {`${item.branch_id}-${item.branch_name}`}
                        </option>
                      ))}
                    </select>

                    <label className={selectedbranch.branch_name ? "filled" : ""}>
                      Select Branch
                    </label>
                  </div> */}



                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select className="form-select" value={addData.branch_id} placeholder=''

                      onChange={(e) => setAddData({ ...addData, branch_id: e.target.value })}
                    >
                      <option value="">Select Branch</option>
                      {branch.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.branch_id} - {item.branch_name}
                        </option>
                      ))}
                    </select>

                    <label className={addData.branch_id ? "filled" : ""}>
                      Select Branch
                    </label>

                  </div>


                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-select"
                      placeholder=""
                      value={addData.type}
                      onChange={(e) => setAddData({ ...addData, type: e.target.value })}
                    >
                      <option value="">Select Type</option>
                      {Array.isArray(responseDatas) &&
                        responseDatas.map((item, index) => (
                          <option key={index} value={item.type}>
                            {item.type}
                          </option>
                        ))}
                    </select>

                    <label className={addData.type ? "filled" : ""}>
                      Select type
                    </label>
                    {errors.type && (
                      <div className="error-text">{errors.type}</div>
                    )}
                  </div>


                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={formatDate(addData.date)}
                      onChange={handleDateChange}
                      required
                    />
                    <label className={addData.date ? "filled" : ""}>Date</label>
                    {errors.date && (
                      <div className="error-text">{errors.date}</div>
                    )}
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.paid_to}
                      onChange={(e) =>
                        setAddData({ ...addData, paid_to: e.target.value })
                      }
                      required
                    />
                    <label className={addData.paid_to ? "filled" : ""}>Insititue / Client</label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.person_name}
                      onChange={(e) =>
                        setAddData({ ...addData, person_name: e.target.value })
                      }
                      required
                    />
                    <label className={addData.person_name ? "filled" : ""}>
                      Person Name
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">


                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-control"
                      value={addData.paid_by}
                      onChange={(e) =>
                        setAddData({ ...addData, paid_by: e.target.value })
                      }
                    >
                      <option value="">Select Paid By</option>
                      <option value="Client">Client</option>
                      <option value="College">College</option>
                      <option value="School">School</option>
                      <option value="Student">Student</option>
                      <option value="Others">Others</option>


                    </select>

                    <label className={addData.paid_by ? "filled" : ""}>
                      Select Paid By
                    </label>
                    {errors.paid_by && (
                      <div className="error-text">{errors.paid_by}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    {addData.paid_by === "Others" && (
                      <div className="other-input">
                        <label className="form-label">Specify Others</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter details"
                          value={addData.other_details || ""}
                          onChange={(e) =>
                            setAddData({ ...addData, other_details: e.target.value })
                          }
                        />
                        {errors.other_details && (
                          <div className="error-text">{errors.other_details}</div>
                        )}
                      </div>
                    )}
                    <label className={addData.other_details ? "filled" : ""}>

                    </label>

                  </div>


                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-select"
                      value={addData.paytype}
                      onChange={(e) =>
                        setAddData({ ...addData, paytype: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Paytype </option>
                      {paymenttype.map((item, index) => (
                        <option key={index} value={item.Payment_type}>
                          {item.Payment_type}
                        </option>
                      ))}
                    </select>
                    <label className={addData.paytype ? "filled" : ""}></label>
                    {errors.paytype && (
                      <div className="error-text">{errors.paytype}</div>
                    )}
                  </div>


                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      placeholder=""
                      value={addData.email}
                      onChange={(e) =>
                        setAddData({ ...addData, email: e.target.value })
                      }
                      required
                    />
                    <label className={addData.email ? "filled" : ""}>
                      Email
                    </label>
                    {errors.email && (
                      <div className="error-text">{errors.email}</div>
                    )}
                  </div>



                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.amount}
                      onChange={(e) =>
                        setAddData({ ...addData, amount: e.target.value })
                      }
                      required
                    />
                    <label className={addData.amount ? "filled" : ""}>
                      Amount
                    </label>
                    {errors.amount && (
                      <div className="error-text">{errors.amount}</div>
                    )}
                  </div>
                  {/* contact: { type: String }, */}

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="tel"
                      placeholder=""
                      value={addData.contact}
                      onChange={(e) =>
                        setAddData({ ...addData, contact: e.target.value })
                      }
                      required
                    />
                    <label className={addData.contact ? "filled" : ""}>
                      Contact No
                    </label>

                  </div>



                </div>
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.description}
                  onChange={(e) =>
                    setAddData({ ...addData, description: e.target.value })
                  }
                  required
                />
                <label className={addData.description ? "filled" : ""}>
                  Notes
                </label>
                {errors.description && (
                  <div className="error-text">{errors.description}</div>
                )}
              </div>
            </div>

            {/* Other input fields */}
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              {" "}
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update Additional Income List</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  {/* <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.branch_name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          branch_id: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.branch_id ? "filled" : ""}>
                      Branch
                    </label>
                  </div> */}



                  <div className="floating-label">
                    <select className="form-select" value={updateData.branch_id} onChange={(e) => setUpdateData({ ...updateData, branch_id: e.target.value })}>
                      <option value="" disabled>Select Branch</option>
                      {branch.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.branch_id} - {item.branch_name}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.branch_id ? "filled" : ""}>

                    </label>

                  </div>

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.type}
                      placeholder=""
                      onChange={(e) =>
                        setUpdateData({ ...updateData, type: e.target.value })
                      }
                    >
                      {responseDatas.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.type ? "filled" : ""}>

                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={formatDatefitching(updateData.date)}
                      onChange={handleDateChange}
                      required
                    />
                    <label className={updateData.date ? "filled" : ""}>
                      Date
                    </label>
                  </div>
                  {/* paid_till_date */}




                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.paid_to}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paid_to: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.paid_to ? "filled" : ""}> Insititue / Client</label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.person_name}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, person_name: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.person_name ? "filled" : ""}>
                      Person Name
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  {/* Other input fields */}

                  {/* <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={updateData.paid_by}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, paid_by: e.target.value })
                    }
                    required
                  />
                  <label className={updateData.paid_by ? "filled" : ""}>
                    Paid by
                  </label>
                </div> */}




                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={updateData.paid_by}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paid_by: e.target.value })
                      }
                    >
                      <option value="Client">Client</option>
                      <option value="College">College</option>
                      <option value="School">School</option>
                      <option value="Student">Student</option>
                      <option value="Others">Others</option>

                    </select>
                    <label className={updateData.paid_by ? "filled" : ""}>
                      Paid By
                    </label>
                  </div>


                  {/* <div className="floating-label">
                  <label className="form-label">
                    <b></b>
                  </label>
                  <select
                    className="form-select"
                    value={updateData.paid_to}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, paid_to: e.target.value })
                    }
                    required
                  >
                    <option value="">Select Paid To </option>
                    {student.map((item, index) => (
                      <option key={index} value={item.leads_id[0]?.student_name}>
                        {item.leads_id[0]?.student_name}- {item.roll_no}
                      </option>
                    ))}
                  </select>
                  <label className={updateData.paid_to ? "filled" : ""}></label>
                </div> */}




                  <div className="floating-label">
                    {updateData.paid_by === "Others" && (
                      <div className="other-input">
                        <label className="form-label">Specify Others</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter details"
                          value={updateData.other_details || ""}
                          onChange={(e) =>
                            setUpdateData({ ...updateData, other_details: e.target.value })
                          }
                        />

                      </div>
                    )}
                    <label className={updateData.other_details ? "filled" : ""}>

                    </label>

                  </div>


                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-select"
                      value={updateData.paytype}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paytype: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Paid To</option>
                      {paymenttype.map((item, index) => (
                        <option key={index} value={item.Payment_type}>
                          {item.Payment_type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.paytype ? "filled" : ""}></label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      placeholder=""
                      value={updateData.email}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, email: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.email ? "filled" : ""}>
                      Email
                    </label>

                  </div>




                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.amount}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, amount: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>
                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\ */}
                  {/* contact */}
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.contact}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, contact: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.contact ? "filled" : ""}>
                      Contact
                    </label>
                  </div>


                </div>
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.description}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      description: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.description ? "filled" : ""}>
                  Notes
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleupdatesubmit}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>



        {/* ========================================================================== */}

        <Modal
          show={ispreviewModal}
          onHide={() => setispreviewModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Preview Additional Income List</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">


                  <div className="floating-label">
                    <select className="form-select" disabled value={updateData.branch_id} onChange={(e) => setUpdateData({ ...updateData, branch_id: e.target.value })}>
                      <option value="" disabled>Select Branch</option>
                      {branch.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.branch_id} - {item.branch_name}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.branch_id ? "filled" : ""}>

                    </label>

                  </div>

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.type}
                      placeholder=""
                      disabled
                      onChange={(e) =>
                        setUpdateData({ ...updateData, type: e.target.value })
                      }
                    >
                      {responseDatas.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.type ? "filled" : ""}>

                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={formatDatefitching(updateData.date)}
                      onChange={handleDateChange}
                      required
                      disabled
                    />
                    <label className={updateData.date ? "filled" : ""}>
                      Date
                    </label>
                  </div>
                  {/* paid_till_date */}
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.paid_to}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paid_to: e.target.value })
                      }
                      required
                      disabled
                    />
                    <label className={updateData.paid_to ? "filled" : ""}> Insititue / Client</label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.person_name}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, person_name: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.person_name ? "filled" : ""}>
                      Person Name
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  {/* Other input fields */}
                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={updateData.paid_by}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paid_by: e.target.value })
                      }
                      disabled
                    >
                      <option value="Client">Client</option>
                      <option value="College">College</option>
                      <option value="School">School</option>
                      <option value="Student">Student</option>
                      <option value="Others">Others</option>

                    </select>
                    <label className={updateData.paid_by ? "filled" : ""}>
                      Paid By
                    </label>
                  </div>






                  <div className="floating-label">
                    {updateData.paid_by === "Others" && (
                      <div className="other-input">
                        <label className="form-label">Specify Others</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter details"
                          value={updateData.other_details || ""}
                          disabled
                          onChange={(e) =>
                            setUpdateData({ ...updateData, other_details: e.target.value })
                          }
                        />

                      </div>
                    )}
                    <label className={updateData.other_details ? "filled" : ""}>

                    </label>

                  </div>


                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-select"
                      value={updateData.paytype}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paytype: e.target.value })
                      }
                      required
                      disabled
                    >
                      <option value="">Select Paid To</option>
                      {paymenttype.map((item, index) => (
                        <option key={index} value={item.Payment_type}>
                          {item.Payment_type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.paytype ? "filled" : ""}></label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      placeholder=""
                      disabled
                      value={updateData.email}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, email: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.email ? "filled" : ""}>
                      Email
                    </label>

                  </div>




                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.amount}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, amount: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>


                  {/* \\\\\\\\\\\\\\\\\\\\\\\\\ */}

                  {/* contact */}

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.contact}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, contact: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.contact ? "filled" : ""}>
                      Contact
                    </label>
                  </div>


                </div>
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.description}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      description: e.target.value,
                    })
                  }
                  required
                  disabled
                />
                <label className={updateData.description ? "filled" : ""}>
                  Notes
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setispreviewModal(false)}
            >
              Cancel
            </Button>

          </Modal.Footer>
        </Modal>



        {/* ----------------delete */}

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1">Description :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* _------------------------------pagination button -------------------------------- */}


        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {currentPage} of {totalPages}
              </span>
            </div>
            <div className="col-lg-5">
              <nav>
                <ul className="pagination justify-content-center">
                  {createPagination()}
                </ul>
              </nav>
            </div>
          </div>
        </div>
        {/* ---------------------------------------end ---------------------------------- */}
      </div>
    </>
  );
}

export default Incomelist;
